import React, { useState, useEffect } from "react";
import { Header } from "../common/Header";
import { Menunav } from "../common/Menunav";
import { Sidebar } from "../common/Sidebar";
import { useNavigate, useParams } from "react-router-dom";
import api from "../../utils/api";
import { useDispatch, useSelector } from "react-redux";
// import {Link } from 'react-router-dom';
import "../projects/projects.css";
import PhoneInput from "react-phone-number-input";
import { Box, Grid, Typography } from "@mui/material";
import Swal from "sweetalert2";
const swalWithBootstrapButtons = Swal.mixin({
  customclassName: {
    confirmButton: "btn btn-success",
    cancelButton: "btn btn-danger",
  },
  buttonsStyling: false,
});

function onlyLettersAndSpaces(str) {
  return /^[A-Za-z\s]*$/.test(str);
}

function onlyNumber(str) {
  return /^\d+$/.test(str);
}
export const Posthostel = () => {
  const params = useParams();
  let navigate = useNavigate();
  const userstate = useSelector((state) => state.loginUserReducer);

  const { currentUser } = userstate;
  const [data, setData] = useState({});
  const [tags, setTags] = useState([]);
  const [errors, setErrors] = useState({});
  const [phoneValue, setPhoneValue] = useState("");
  const [facilities, setFacilities] = useState([]);
  const [hostelImages, setHostelImages] = useState([]);
  const [uploadedImageLink, setUploadedImageLink] = useState("");

  useEffect(() => {
    if (params?.hostelId) {
      api
        .get(`/hostels/by-id/${params.hostelId}`)
        .then((res) => {
          if (res.data) {
            console.log("hostel for edit", res.data);
            // setQuestion(res.data?.question);
            // setDescription(res.data?.description);
            setHostelImages(res.data?.hostelImages);
            setTags(res.data?.tags);
            setFacilities(res?.data?.facilities);
            // setPhoneValue(res.data?.contact);
            // let temp = {
            //   hostelName: res.data?.hostelName,
            //   hostelImage: res.data?.hostelImage,
            //   location: res.data?.location,
            //   description: res.data?.description,
            //   price: parseInt(res.data?.price),
            //   contact: res.data?.contact,
            //   tags: res.data?.tags,
            // };
            // console.log("temp", temp);
            setData(res?.data?.generalData);
            // setTags(res.data?.tags);
          }
        })
        .catch((err) => console.log);
    }
  }, []);
  const onChange = (e) => {
    let temp = Object.assign(data, { [e.target.name]: e.target.value });
    setData(temp);
    console.log("updated data>> ", temp);
    if (e.target.name == "tagsText") {
      const Array = e.target.value?.split(",");
      let Array2 = Array.filter((arr) => arr !== "");
      setTags(Array2);
    }
  };
  const onChangeFacilities = (e) => {
    let fs = facilities;
    let arr = fs;
    console.log("name check", e.target.name, e.target.checked);
    if (e.target.checked) {
      arr = [...arr, e.target.name];
    } else {
      arr = fs.filter((a) => a !== e.target.name);
    }

    setFacilities(arr);
    console.log("facilities", facilities);
  };
  useEffect(() => {
    let e = {
      target: {
        name: "contact",
        value: phoneValue,
      },
    };
    onChange(e);
  }, [phoneValue]);
  const uploadHostelImage = async (e) => {
    console.log(e.target);
    console.log("running upload file ");
    let files = e.target.files;
    if (files?.length > 0) {
      const dataa = new FormData();
      dataa.append("file", files[0]);
      dataa.append("upload_preset", "bpyoqbty");
      console.log("dataa", dataa);

      const res = await fetch(
        "https://api.cloudinary.com/v1_1/dqmbkvawu/image/upload",

        {
          method: "POST",
          body: dataa,
        }
      );
      const file = await res.json();
      console.log("response from cloudinary>>>", file);
      setUploadedImageLink(file?.secure_url);
      // setHostelImage(file?.secure_url);

      // let e2 = { target: { name: "hostelImage", value: file?.secure_url } };
      // onChange(e2);
    }

    // console.log("file profie image>>> ", file);
  };
  const addHostelImage = () => {
    let arr = hostelImages;
    console.log("uploadedImageLink", uploadedImageLink);
    if (uploadedImageLink && hostelImages?.length < 6) {
      arr.push(uploadedImageLink);
      console.log("uploadedImageLink", uploadedImageLink);
      setUploadedImageLink("");
      setHostelImages(arr);
    }
    console.log("hostel images", arr);
  };
  const submitData = (e) => {
    e.preventDefault();
    // console.log("data", data);
    // console.log("tags", tags);
    // console.log("facilities", facilities);
    // console.log("images", hostelImages);
    // return;
    /**************** */
    let errs = {};
    if (!data.hostelName) {
      errs.hostelName = "required";
    } else if (!onlyLettersAndSpaces(data.hostelName)) {
      errs.hostelName = "must contain letters only";
    }
    // if (!data.location) {
    //   errs.location = "required";
    // }
    if (!data.state) {
      errs.state = "required";
    }
    if (!data.hostelCategory) {
      errs.hostelCategory = "required";
    }
    if (!data.city) {
      errs.city = "required";
    }
    if (!data.hostelAddress) {
      errs.hostelAddress = "required";
    }
    if (!data.hostelDetails) {
      errs.hostelDetails = "required";
    }
    if (!data.hostelLocationLink) {
      errs.hostelLocationLink = "required";
    }
    if (!data.estimatedRent) {
      errs.estimatedRent = "required";
    }
    if (!data.billsIncluded) {
      errs.billsIncluded = "required";
    }
    if (!data.rentPeriod) {
      errs.rentPeriod = "required";
    }
    if (!data.hostelCondition) {
      errs.hostelCondition = "required";
    }
    if (!data.membersPerRoom) {
      errs.membersPerRoom = "required";
    }
    if (!data.numberOfRooms) {
      errs.numberOfRooms = "required";
    }

    if (!data.contact) {
      errs.contact = "required";
    }
    // if (hostelImages?.length < 1) {
    //   errs.hostelImages = "images are required";
    // }

    if (!data.tagsText && !params?.hostelId) {
      errs.tags = "tags are required";
    }

    if (tags.length < 2 || tags.length > 5) {
      errs.tags = "atleast 2 tags are required , atmost 5";
    }

    setErrors(errs);
    console.log("errs", errs);
    if (Object.keys(errs).length === 0 && errs.constructor === Object) {
      // let body = Object.assign(data, { userId: currentUser?.id });
      let body = {
        userId: currentUser?.id,
        generalData: data,
        facilities,
        hostelImages,
        tags: tags,
      };
      if (params?.hostelId) {
        //updating hostel data
        api
          .put(`/hostels/update/${params?.hostelId}`, body)
          .then((res) => {
            if (res.data) {
              Swal.fire("Hostel Updated Successfully!", "", "success");
              navigate("/my-hostels");
            }
          })
          .catch((err) => {
            alert("hostel post failed");
            swalWithBootstrapButtons.fire(
              "Hostel Updation Unsuccessful!",
              "Something goes wrong",
              "error"
            );
          });
      } else {
        console.log("submitting data", body);
        api
          .post("/hostels", body)
          .then((res) => {
            console.log(res.data);
            Swal.fire("Hostel Uploaded Successfully!", "", "success");
            let notifBody = {
              userId: currentUser?.id,
              text: `${currentUser?.name} post new Hostel.`,
            };
            api
              .post("/notifications", notifBody)
              .then((re) => console.log("notif", re.data));
            navigate("/hostels");
          })
          .catch((err) => {
            console.log(err);
            swalWithBootstrapButtons.fire(
              "Hostel Submission Unsuccessful!",
              "Something goes wrong",
              "error"
            );
          });
      }
    }
  };

  return (
    // <Box>
    //   {/* <Header />
    //   <Menunav /> */}
    //   <Box className="row">
    //     {/* <Box className="col-md-2 col-0">
    //       <Sidebar />
    //     </Box> */}
    //     <Box className="col-md-10 col-12">
    //       <Box className="container p-4">
    //         <Typography
    //           variant="h6"
    //           sx={{ fontWeight: "600", marginBottom: "20px" }}
    //         >
    //           {params?.hostelId ? "Edit Your Hostel" : "Add New Hostel"}
    //         </Typography>
    //         <Box className="form">
    //           <Box className="row">
    //             <Box className="col-lg-6 col-md-6 col-12">
    //               <input
    //                 className="text-feild firstBox_of_projects input__field__asc"
    //                 id="name_of_hostel"
    //                 placeholder="Name*"
    //                 name="hostelName"
    //                 required
    //                 onChange={(e) => onChange(e)}
    //               />
    //               {errors.hostelName && (
    //                 <p className="error__para">{errors.hostelName}</p>
    //               )}
    //             </Box>
    //             <Box className="col-lg-6 col-md-6 col-12">
    //               <input
    //                 className="text-feild firstBox_of_projects input__field__asc"
    //                 id="location_of_hostel"
    //                 placeholder="Location*"
    //                 name="location"
    //                 required
    //                 onChange={(e) => onChange(e)}
    //               />
    //               {errors.location && (
    //                 <p className="error__para">{errors.location}</p>
    //               )}
    //             </Box>
    //           </Box>
    //           <Box className="row">
    //             <Box className="col-lg-6 col-md-6 col-12">
    //               <input
    //                 className="text-feild firstBox_of_projects input__field__asc"
    //                 id="price_of_hostel"
    //                 placeholder="Price Per head*"
    //                 name="price"
    //                 required
    //                 onChange={(e) => onChange(e)}
    //               />
    //               {errors.price && (
    //                 <p className="error__para">{errors.price}</p>
    //               )}
    //             </Box>
    //             <Box className="col-lg-6 col-md-6 col-12">
    //               {/* <input
    //                 className="text-feild firstBox_of_projects"
    //                 id="contact_of_hostel"
    //                 placeholder="Contact Detail*"
    //                 name="contact"
    //                 required
    //                 onChange={(e) => onChange(e)}
    //               /> */}
    //               <PhoneInput
    //                 placeholder="Enter phone number"
    //                 className=" input__field__asc text-feild firstBox_of_projects "
    //                 //value={phoneValue}
    //                 onChange={(value) => setPhoneValue(value)}
    //               />
    //               {errors.contact && (
    //                 <p className="error__para">{errors.contact}</p>
    //               )}
    //             </Box>
    //           </Box>
    //           <Box className="row">
    //             <Box className="col-lg-6 col-md-6 col-12">
    //               <input
    //                 className="text-feild firstBox_of_projects input__field__asc"
    //                 id="meal_price"
    //                 placeholder="Meal Price per month"
    //                 name="meal_price"
    //                 required
    //                 onChange={(e) => onChange(e)}
    //               />
    //               {errors.meal_price && (
    //                 <p className="error__para">{errors.meal_price}</p>
    //               )}
    //             </Box>
    //             <Box className="col-lg-6 col-md-6 col-12"></Box>
    //           </Box>
    //           <Box className="row mt-2">
    //             <input
    //               className="text-feild firstBox_of_projects input__field__asc input-file"
    //               type="file"
    //               onClick={(e) => uploadHostelImage(e)}
    //             />
    //             {hostelImage && (
    //               <img
    //                 src={hostelImage}
    //                 style={{ margin: "3vh 3vw", width: "auto", height: "30vh" }}
    //               />
    //             )}
    //             {errors.hostelImage && (
    //               <p className="error__para">{errors.hostelImage}</p>
    //             )}
    //           </Box>
    //           <input
    //             className="text-feild input__field__asc"
    //             id="tags_of_hostel"
    //             placeholder="Tags"
    //             name="tagsText"
    //             required
    //             onChange={(e) => onChange(e)}
    //           />
    //           {errors.tags && <p className="error__para">{errors.tags}</p>}
    //           <p>Tags : </p>
    //           {tags && (
    //             <Box className="tags__container">
    //               {tags.map((tag) => (
    //                 <span>{tag} </span>
    //               ))}
    //             </Box>
    //           )}
    //           <textarea
    //             className="text-feild input__field__asc"
    //             id="description_of_hostel"
    //             placeholder="Description"
    //             name="description"
    //             required
    //             onChange={(e) => onChange(e)}
    //           />
    //           {errors.description && (
    //             <p className="error__para">{errors.description}</p>
    //           )}

    //           <Box name="date" id="date" required />
    //           <button
    //             className=" mt-3 asc__submit__form__button"
    //             id="submitbutton_of_projects"
    //             onClick={(e) => submitData(e)}
    //           >
    //             {params?.hostelId ? "Update" : "Submit"}
    //           </button>
    //         </Box>
    //       </Box>
    //     </Box>
    //   </Box>
    // </Box>
    <Box>
      {/* <Header />
    <Menunav /> */}
      <Box className="row">
        {/* <Box className="col-md-2 col-0">
        <Sidebar />
      </Box> */}
        <Box className="col-md-12 col-12">
          <Box className="container p-4">
            {/* <Typography
              variant="h6"
              sx={{ fontWeight: "400", marginBottom: "20px" }}
            >
              {params?.hostelId ? "Edit Your Hostel" : "Add New Hostel"}
            </Typography> */}
            <Box className="form">
              <Box className="row">
                <Box className="col-12 col-sm-12 col-md-6">
                  <input
                    className="text-feild input__field__asc"
                    id="hostelName"
                    placeholder="Hostel name"
                    name="hostelName"
                    required
                    defaultValue={data?.hostelName}
                    onChange={(e) => onChange(e)}
                  />
                  {errors.hostelName && (
                    <p className="error__para">{errors.hostelName}</p>
                  )}
                </Box>
                <Box className="col-12 col-sm-12 col-md-6">
                  <PhoneInput
                    placeholder="Hostel phone number"
                    className=" input__field__asc text-feild firstBox_of_projects "
                    //value={phoneValue}
                    onChange={(value) => setPhoneValue(value)}
                  />
                  {errors.contact && (
                    <p className="error__para">{errors.contact}</p>
                  )}
                </Box>
              </Box>
              <Box className="row" style={{ marginTop: "20px" }}>
                <Box className="col-12 col-sm-12 col-md-4">
                  <select
                    name="state"
                    required
                    onChange={(e) => onChange(e)}
                    className="text-feild input__field__asc"
                    defaultValue={data?.state}
                  >
                    <option value="">Province</option>
                    <option value="Punjab">Punjab</option>
                    <option value="Sindh">Sindh</option>
                    <option value="Balochistan">Balochistan</option>
                    <option value="KPK">KPK</option>
                    <option value="AJK">AJK</option>
                    <option value="Gilgit Baltistan">Gilgit Baltistan</option>
                  </select>
                  {errors.state && (
                    <p className="error__para">{errors.state}</p>
                  )}
                </Box>
                <Box
                  className="col-12 col-sm-12 col-md-4"
                  sx={{
                    display: "flex",
                    alignItems: "left",
                    gap: "10px",
                    flexDirection: "column",
                    justifyContent: "center",
                    paddingTop: "10px",
                  }}
                >
                  <select
                    name="hostelCategory"
                    id="hostelCategory"
                    onChange={(e) => onChange(e)}
                    className="input__field__asc"
                    defaultValue={data?.hostelCategory}

                    // defaultValue={boatGeneralDetails?.Style}
                  >
                    <option>Choose Category</option>
                    <option value="Female Hostel">Female Hostel</option>
                    <option value="Male Hostel">Male Hostel</option>
                    <option value="Staff Hostel">Staff Hostel</option>
                  </select>
                  {errors.hostelCategory && (
                    <p className="error__para">{errors.hostelCategory}</p>
                  )}
                </Box>
                <Box className="col-12 col-sm-12 col-md-4">
                  <select
                    name="city"
                    className="text-feild input__field__asc"
                    onChange={(e) => onChange(e)}
                    required
                  >
                    <option value="" disabled selected>
                      Select City
                    </option>
                    <option value="Islamabad">Islamabad</option>
                    <option value="" disabled>
                      Punjab Cities
                    </option>
                    <option value="Ahmed Nager Chatha">
                      Ahmed Nager Chatha
                    </option>
                    <option value="Ahmadpur East">Ahmadpur East</option>
                    <option value="Ali Khan Abad">Ali Khan Abad</option>
                    <option value="Alipur">Alipur</option>
                    <option value="Arifwala">Arifwala</option>
                    <option value="Attock">Attock</option>
                    <option value="Bhera">Bhera</option>
                    <option value="Bhalwal">Bhalwal</option>
                    <option value="Bahawalnagar">Bahawalnagar</option>
                    <option value="Bahawalpur">Bahawalpur</option>
                    <option value="Bhakkar">Bhakkar</option>
                    <option value="Burewala">Burewala</option>
                    <option value="Chillianwala">Chillianwala</option>
                    <option value="Chakwal">Chakwal</option>
                    <option value="Chichawatni">Chichawatni</option>
                    <option value="Chiniot">Chiniot</option>
                    <option value="Chishtian">Chishtian</option>
                    <option value="Daska">Daska</option>
                    <option value="Darya Khan">Darya Khan</option>
                    <option value="Dera Ghazi Khan">Dera Ghazi Khan</option>
                    <option value="Dhaular">Dhaular</option>
                    <option value="Dina">Dina</option>
                    <option value="Dinga">Dinga</option>
                    <option value="Dipalpur">Dipalpur</option>
                    <option value="Faisalabad">Faisalabad</option>
                    <option value="Ferozewala">Ferozewala</option>
                    <option value="Fateh Jhang">Fateh Jang</option>
                    <option value="Ghakhar Mandi">Ghakhar Mandi</option>
                    <option value="Gojra">Gojra</option>
                    <option value="Gujranwala">Gujranwala</option>
                    <option value="Gujrat">Gujrat</option>
                    <option value="Gujar Khan">Gujar Khan</option>
                    <option value="Hafizabad">Hafizabad</option>
                    <option value="Haroonabad">Haroonabad</option>
                    <option value="Hasilpur">Hasilpur</option>
                    <option value="Haveli Lakha">Haveli Lakha</option>
                    <option value="Jatoi">Jatoi</option>
                    <option value="Jalalpur">Jalalpur</option>
                    <option value="Jattan">Jattan</option>
                    <option value="Jampur">Jampur</option>
                    <option value="Jaranwala">Jaranwala</option>
                    <option value="Jhang">Jhang</option>
                    <option value="Jhelum">Jhelum</option>
                    <option value="Kalabagh">Kalabagh</option>
                    <option value="Karor Lal Esan">Karor Lal Esan</option>
                    <option value="Kasur">Kasur</option>
                    <option value="Kamalia">Kamalia</option>
                    <option value="Kamoke">Kamoke</option>
                    <option value="Khanewal">Khanewal</option>
                    <option value="Khanpur">Khanpur</option>
                    <option value="Kharian">Kharian</option>
                    <option value="Khushab">Khushab</option>
                    <option value="Kot Addu">Kot Addu</option>
                    <option value="Jauharabad">Jauharabad</option>
                    <option value="Lahore">Lahore</option>
                    <option value="Lalamusa">Lalamusa</option>
                    <option value="Layyah">Layyah</option>
                    <option value="Liaquat Pur">Liaquat Pur</option>
                    <option value="Lodhran">Lodhran</option>
                    <option value="Malakwal">Malakwal</option>
                    <option value="Mamoori">Mamoori</option>
                    <option value="Mailsi">Mailsi</option>
                    <option value="Mandi Bahauddin">Mandi Bahauddin</option>
                    <option value="Mian Channu">Mian Channu</option>
                    <option value="Mianwali">Mianwali</option>
                    <option value="Multan">Multan</option>
                    <option value="Murree">Murree</option>
                    <option value="Muridke">Muridke</option>
                    <option value="Mianwali Bangla">Mianwali Bangla</option>
                    <option value="Muzaffargarh">Muzaffargarh</option>
                    <option value="Narowal">Narowal</option>
                    <option value="Nankana Sahib">Nankana Sahib</option>
                    <option value="Okara">Okara</option>
                    <option value="Renala Khurd">Renala Khurd</option>
                    <option value="Pakpattan">Pakpattan</option>
                    <option value="Pattoki">Pattoki</option>
                    <option value="Pir Mahal">Pir Mahal</option>
                    <option value="Qaimpur">Qaimpur</option>
                    <option value="Qila Didar Singh">Qila Didar Singh</option>
                    <option value="Rabwah">Rabwah</option>
                    <option value="Raiwind">Raiwind</option>
                    <option value="Rajanpur">Rajanpur</option>
                    <option value="Rahim Yar Khan">Rahim Yar Khan</option>
                    <option value="Rawalpindi">Rawalpindi</option>
                    <option value="Sadiqabad">Sadiqabad</option>
                    <option value="Safdarabad">Safdarabad</option>
                    <option value="Sahiwal">Sahiwal</option>
                    <option value="Sangla Hill">Sangla Hill</option>
                    <option value="Sarai Alamgir">Sarai Alamgir</option>
                    <option value="Sargodha">Sargodha</option>
                    <option value="Shakargarh">Shakargarh</option>
                    <option value="Sheikhupura">Sheikhupura</option>
                    <option value="Sialkot">Sialkot</option>
                    <option value="Sohawa">Sohawa</option>
                    <option value="Soianwala">Soianwala</option>
                    <option value="Siranwali">Siranwali</option>
                    <option value="Talagang">Talagang</option>
                    <option value="Taxila">Taxila</option>
                    <option value="Toba Tek Singh">Toba Tek Singh</option>
                    <option value="Vehari">Vehari</option>
                    <option value="Wah Cantonment">Wah Cantonment</option>
                    <option value="Wazirabad">Wazirabad</option>
                    <option value="" disabled>
                      Sindh Cities
                    </option>
                    <option value="Badin">Badin</option>
                    <option value="Bhirkan">Bhirkan</option>
                    <option value="Rajo Khanani">Rajo Khanani</option>
                    <option value="Chak">Chak</option>
                    <option value="Dadu">Dadu</option>
                    <option value="Digri">Digri</option>
                    <option value="Diplo">Diplo</option>
                    <option value="Dokri">Dokri</option>
                    <option value="Ghotki">Ghotki</option>
                    <option value="Haala">Haala</option>
                    <option value="Hyderabad">Hyderabad</option>
                    <option value="Islamkot">Islamkot</option>
                    <option value="Jacobabad">Jacobabad</option>
                    <option value="Jamshoro">Jamshoro</option>
                    <option value="Jungshahi">Jungshahi</option>
                    <option value="Kandhkot">Kandhkot</option>
                    <option value="Kandiaro">Kandiaro</option>
                    <option value="Karachi">Karachi</option>
                    <option value="Kashmore">Kashmore</option>
                    <option value="Keti Bandar">Keti Bandar</option>
                    <option value="Khairpur">Khairpur</option>
                    <option value="Kotri">Kotri</option>
                    <option value="Larkana">Larkana</option>
                    <option value="Matiari">Matiari</option>
                    <option value="Mehar">Mehar</option>
                    <option value="Mirpur Khas">Mirpur Khas</option>
                    <option value="Mithani">Mithani</option>
                    <option value="Mithi">Mithi</option>
                    <option value="Mehrabpur">Mehrabpur</option>
                    <option value="Moro">Moro</option>
                    <option value="Nagarparkar">Nagarparkar</option>
                    <option value="Naudero">Naudero</option>
                    <option value="Naushahro Feroze">Naushahro Feroze</option>
                    <option value="Naushara">Naushara</option>
                    <option value="Nawabshah">Nawabshah</option>
                    <option value="Nazimabad">Nazimabad</option>
                    <option value="Qambar">Qambar</option>
                    <option value="Qasimabad">Qasimabad</option>
                    <option value="Ranipur">Ranipur</option>
                    <option value="Ratodero">Ratodero</option>
                    <option value="Rohri">Rohri</option>
                    <option value="Sakrand">Sakrand</option>
                    <option value="Sanghar">Sanghar</option>
                    <option value="Shahbandar">Shahbandar</option>
                    <option value="Shahdadkot">Shahdadkot</option>
                    <option value="Shahdadpur">Shahdadpur</option>
                    <option value="Shahpur Chakar">Shahpur Chakar</option>
                    <option value="Shikarpaur">Shikarpaur</option>
                    <option value="Sukkur">Sukkur</option>
                    <option value="Tangwani">Tangwani</option>
                    <option value="Tando Adam Khan">Tando Adam Khan</option>
                    <option value="Tando Allahyar">Tando Allahyar</option>
                    <option value="Tando Muhammad Khan">
                      Tando Muhammad Khan
                    </option>
                    <option value="Thatta">Thatta</option>
                    <option value="Umerkot">Umerkot</option>
                    <option value="Warah">Warah</option>
                    <option value="" disabled>
                      Khyber Cities
                    </option>
                    <option value="Abbottabad">Abbottabad</option>
                    <option value="Adezai">Adezai</option>
                    <option value="Alpuri">Alpuri</option>
                    <option value="Akora Khattak">Akora Khattak</option>
                    <option value="Ayubia">Ayubia</option>
                    <option value="Banda Daud Shah">Banda Daud Shah</option>
                    <option value="Bannu">Bannu</option>
                    <option value="Batkhela">Batkhela</option>
                    <option value="Battagram">Battagram</option>
                    <option value="Birote">Birote</option>
                    <option value="Chakdara">Chakdara</option>
                    <option value="Charsadda">Charsadda</option>
                    <option value="Chitral">Chitral</option>
                    <option value="Daggar">Daggar</option>
                    <option value="Dargai">Dargai</option>
                    <option value="Darya Khan">Darya Khan</option>
                    <option value="Dera Ismail Khan">Dera Ismail Khan</option>
                    <option value="Doaba">Doaba</option>
                    <option value="Dir">Dir</option>
                    <option value="Drosh">Drosh</option>
                    <option value="Hangu">Hangu</option>
                    <option value="Haripur">Haripur</option>
                    <option value="Karak">Karak</option>
                    <option value="Kohat">Kohat</option>
                    <option value="Kulachi">Kulachi</option>
                    <option value="Lakki Marwat">Lakki Marwat</option>
                    <option value="Latamber">Latamber</option>
                    <option value="Madyan">Madyan</option>
                    <option value="Mansehra">Mansehra</option>
                    <option value="Mardan">Mardan</option>
                    <option value="Mastuj">Mastuj</option>
                    <option value="Mingora">Mingora</option>
                    <option value="Nowshera">Nowshera</option>
                    <option value="Paharpur">Paharpur</option>
                    <option value="Pabbi">Pabbi</option>
                    <option value="Peshawar">Peshawar</option>
                    <option value="Saidu Sharif">Saidu Sharif</option>
                    <option value="Shorkot">Shorkot</option>
                    <option value="Shewa Adda">Shewa Adda</option>
                    <option value="Swabi">Swabi</option>
                    <option value="Swat">Swat</option>
                    <option value="Tangi">Tangi</option>
                    <option value="Tank">Tank</option>
                    <option value="Thall">Thall</option>
                    <option value="Timergara">Timergara</option>
                    <option value="Tordher">Tordher</option>
                    <option value="" disabled>
                      Balochistan Cities
                    </option>
                    <option value="Awaran">Awaran</option>
                    <option value="Barkhan">Barkhan</option>
                    <option value="Chagai">Chagai</option>
                    <option value="Dera Bugti">Dera Bugti</option>
                    <option value="Gwadar">Gwadar</option>
                    <option value="Harnai">Harnai</option>
                    <option value="Jafarabad">Jafarabad</option>
                    <option value="Jhal Magsi">Jhal Magsi</option>
                    <option value="Kacchi">Kacchi</option>
                    <option value="Kalat">Kalat</option>
                    <option value="Kech">Kech</option>
                    <option value="Kharan">Kharan</option>
                    <option value="Khuzdar">Khuzdar</option>
                    <option value="Killa Abdullah">Killa Abdullah</option>
                    <option value="Killa Saifullah">Killa Saifullah</option>
                    <option value="Kohlu">Kohlu</option>
                    <option value="Lasbela">Lasbela</option>
                    <option value="Lehri">Lehri</option>
                    <option value="Loralai">Loralai</option>
                    <option value="Mastung">Mastung</option>
                    <option value="Musakhel">Musakhel</option>
                    <option value="Nasirabad">Nasirabad</option>
                    <option value="Nushki">Nushki</option>
                    <option value="Panjgur">Panjgur</option>
                    <option value="Pishin Valley">Pishin Valley</option>
                    <option value="Quetta">Quetta</option>
                    <option value="Sherani">Sherani</option>
                    <option value="Sibi">Sibi</option>
                    <option value="Sohbatpur">Sohbatpur</option>
                    <option value="Washuk">Washuk</option>
                    <option value="Zhob">Zhob</option>
                    <option value="Ziarat">Ziarat</option>
                  </select>
                  {errors.city && <p className="error__para">{errors.city}</p>}
                </Box>
              </Box>
              <Box className="row" style={{ marginTop: "20px" }}>
                <Box className="col-12 col-sm-12 col-md-12">
                  <input
                    className="text-feild input__field__asc"
                    id="hostelAddress"
                    placeholder="address"
                    name="hostelAddress"
                    defaultValue={data?.hostelAddress}
                    required
                    onChange={(e) => onChange(e)}
                  />
                  {errors.hostelAddress && (
                    <p className="error__para">{errors.hostelAddress}</p>
                  )}
                </Box>
              </Box>
              <Box className="row" style={{ marginTop: "20px" }}>
                <Box className="col-12 col-sm-12 col-md-6">
                  <textarea
                    className="text-feild input__field__asc"
                    id="hostelDetails"
                    placeholder="write details"
                    name="hostelDetails"
                    defaultValue={data?.hostelDetails}
                    required
                    onChange={(e) => onChange(e)}
                    height="300px"
                  />
                  {errors?.hostelDetails && (
                    <p className="error__para">{errors?.hostelDetails}</p>
                  )}
                </Box>
                <Box className="col-12 col-sm-12 col-md-6">
                  <input
                    className="text-feild input__field__asc"
                    id="hostelLocationLink"
                    placeholder="hostel location - google map link"
                    name="hostelLocationLink"
                    defaultValue={data?.hostelLocationLink}
                    required
                    onChange={(e) => onChange(e)}
                    style={{ height: "55px" }}
                  />
                  {errors.hostelLocationLink && (
                    <p className="error__para">{errors.hostelLocationLink}</p>
                  )}
                </Box>
              </Box>
              <Box className="row " sx={{ marginBottom: "50px" }}>
                <Typography
                  className="col-12 mt-4"
                  variant="h6"
                  sx={{ textAlign: "center", marginBottom: "20px" }}
                >
                  Hostel Pictures
                </Typography>
                <Box className="col-12 col-sm-12 col-md-9">
                  <input
                    type="file"
                    className="text-feild input__field__asc"
                    id=""
                    placeholder="write details"
                    name=""
                    required
                    onChange={(e) => uploadHostelImage(e)}
                    height="300px"
                  />
                </Box>
                <Box className="col-12 col-sm-12 col-md-3">
                  <button
                    className="asc__submit__form__button"
                    style={{ marginTop: "13px" }}
                    onClick={() => addHostelImage()}
                  >
                    Add Image
                  </button>
                </Box>
                <Typography>Note: you can add up to 6 images</Typography>
                {errors.hostelImages && (
                  <p className="error__para">{errors.hostelImages}</p>
                )}
                <Grid container gap={3} sx={{ marginTop: "20px" }}>
                  {hostelImages?.map((img) => (
                    <Grid item sm={3} xs={12}>
                      <img src={img} height="300px" width="300px" />
                    </Grid>
                  ))}
                </Grid>
              </Box>

              <Box className="row " sx={{ marginBottom: "50px" }}>
                <Typography
                  className="col-12 mt-4"
                  variant="h6"
                  sx={{ textAlign: "center", marginBottom: "20px" }}
                >
                  Rent and Area
                </Typography>
                <Box className="col-12 col-sm-12 col-md-4">
                  <input
                    type="number"
                    min="0"
                    className="text-feild input__field__asc"
                    id="estimatedRent"
                    placeholder="Estimated rent per month"
                    name="estimatedRent"
                    required
                    defaultValue={data?.estimatedRent}
                    onChange={(e) => onChange(e)}
                    height="300px"
                  />
                  {errors.estimatedRent && (
                    <p className="error__para">{errors.estimatedRent}</p>
                  )}
                </Box>
                <Box
                  className="col-12 col-sm-12 col-md-4"
                  sx={{
                    display: "flex",
                    alignItems: "left",
                    gap: "10px",
                    flexDirection: "column",
                    justifyContent: "center",
                    paddingTop: "10px",
                  }}
                >
                  <select
                    name="billsIncluded"
                    id="billsIncluded"
                    onChange={(e) => onChange(e)}
                    className="input__field__asc"

                    // defaultValue={boatGeneralDetails?.Style}
                  >
                    <option>Bills Included</option>
                    <option value="residence and electricity">
                      residence and electricity
                    </option>
                    <option value="residence, electricity and mess">
                      residence, electricity and mess
                    </option>
                    <option value="All Faciities">All Faciities</option>
                  </select>
                  {errors.billsIncluded && (
                    <p className="error__para">{errors.billsIncluded}</p>
                  )}
                </Box>
                <Box
                  className="col-12 col-sm-12 col-md-4"
                  sx={{
                    display: "flex",
                    alignItems: "left",
                    gap: "10px",
                    flexDirection: "column",
                    justifyContent: "center",
                    paddingTop: "10px",
                  }}
                >
                  <select
                    name="rentPeriod"
                    id="rentPeriod"
                    onChange={(e) => onChange(e)}
                    className="input__field__asc"

                    // defaultValue={boatGeneralDetails?.Style}
                  >
                    <option>Rent Period</option>
                    <option value="Weekly">Weekly</option>
                    <option value="Monthly">Monthly</option>
                    <option value="Annual">Annual</option>
                  </select>
                  {errors.rentPeriod && (
                    <p className="error__para">{errors.rentPeriod}</p>
                  )}
                </Box>
                <Box
                  className="col-12 col-sm-12 col-md-4"
                  sx={{
                    display: "flex",
                    alignItems: "left",
                    gap: "10px",
                    flexDirection: "column",
                    justifyContent: "center",
                    paddingTop: "10px",
                  }}
                >
                  <select
                    name="hostelCondition"
                    id="hostelCondition"
                    onChange={(e) => onChange(e)}
                    className="input__field__asc"

                    // defaultValue={boatGeneralDetails?.Style}
                  >
                    <option>Condition</option>
                    <option value="Perfect">Perfect</option>
                    <option value="Good">Good</option>
                    <option value="Adjustable">Adjustable</option>
                  </select>
                  {errors.hostelCondition && (
                    <p className="error__para">{errors.hostelCondition}</p>
                  )}
                </Box>
                <Box className="col-12 col-sm-12 col-md-4">
                  <input
                    type="number"
                    min="0"
                    className="text-feild input__field__asc"
                    id="membersPerRoom"
                    placeholder="Memebers per room"
                    name="membersPerRoom"
                    defaultValue={data?.membersPerRoom}
                    required
                    onChange={(e) => onChange(e)}
                    height="300px"
                  />
                  {errors.membersPerRoom && (
                    <p className="error__para">{errors.membersPerRoom}</p>
                  )}
                </Box>
                <Box className="col-12 col-sm-12 col-md-4">
                  <input
                    type="number"
                    min="0"
                    className="text-feild input__field__asc"
                    id="numberOfRooms"
                    placeholder="Number of Rooms"
                    name="numberOfRooms"
                    defaultValue={data?.numberOfRooms}
                    required
                    onChange={(e) => onChange(e)}
                    height="300px"
                  />
                  {errors.numberOfRooms && (
                    <p className="error__para">{errors.numberOfRooms}</p>
                  )}
                </Box>
              </Box>
              <Box className="row " sx={{ marginBottom: "50px" }}>
                <Typography
                  className="col-12 mt-4 "
                  variant="h6"
                  sx={{ textAlign: "center", marginBottom: "30px" }}
                >
                  Facilities
                </Typography>
                <Box
                  className="col-12 col-sm-6 col-md-3"
                  sx={{
                    display: "flex",
                    justifyContent: "left",
                    gap: "10px",
                    alignItems: "center",
                  }}
                >
                  <input
                    type="checkbox"
                    className=""
                    id="wifi"
                    placeholder="Estimated rent per month"
                    name="wifi"
                    required
                    onChange={(e) => onChangeFacilities(e)}
                    height="300px"
                    checked={facilities?.includes("wifi")}
                  />
                  <Typography>Wifi</Typography>
                </Box>
                <Box
                  className="col-12 col-sm-6 col-md-3"
                  sx={{
                    display: "flex",
                    justifyContent: "left",
                    gap: "10px",
                    alignItems: "center",
                  }}
                >
                  <input
                    type="checkbox"
                    className=""
                    id="geyser"
                    placeholder="Estimated rent per month"
                    name="geyser"
                    required
                    onChange={(e) => onChangeFacilities(e)}
                    height="300px"
                    checked={facilities?.includes("geyser")}
                  />
                  <Typography>Geyser</Typography>
                </Box>
                <Box
                  className="col-12 col-sm-6 col-md-3"
                  sx={{
                    display: "flex",
                    justifyContent: "left",
                    gap: "10px",
                    alignItems: "center",
                  }}
                >
                  <input
                    type="checkbox"
                    className=""
                    id="electricityBackup"
                    placeholder="Estimated rent per month"
                    name="electricityBackup"
                    required
                    onChange={(e) => onChangeFacilities(e)}
                    height="300px"
                    checked={facilities?.includes("electricityBackup")}
                  />
                  <Typography>Eectricity Backup</Typography>
                </Box>
                <Box
                  className="col-12 col-sm-6 col-md-3"
                  sx={{
                    display: "flex",
                    justifyContent: "left",
                    gap: "10px",
                    alignItems: "center",
                  }}
                >
                  <input
                    type="checkbox"
                    className=""
                    id="laundry"
                    placeholder="Estimated rent per month"
                    name="laundry"
                    required
                    onChange={(e) => onChangeFacilities(e)}
                    height="300px"
                    checked={facilities?.includes("laundry")}
                  />
                  <Typography>Laundry</Typography>
                </Box>
                <Box
                  className="col-12 col-sm-6 col-md-3"
                  sx={{
                    display: "flex",
                    justifyContent: "left",
                    gap: "10px",
                    alignItems: "center",
                  }}
                >
                  <input
                    type="checkbox"
                    className=""
                    id="oven"
                    placeholder="Estimated rent per month"
                    name="oven"
                    required
                    onChange={(e) => onChangeFacilities(e)}
                    height="300px"
                    checked={facilities?.includes("oven")}
                  />
                  <Typography>Oven</Typography>
                </Box>
                <Box
                  className="col-12 col-sm-6 col-md-3"
                  sx={{
                    display: "flex",
                    justifyContent: "left",
                    gap: "10px",
                    alignItems: "center",
                  }}
                >
                  <input
                    type="checkbox"
                    className=""
                    id="roofTop"
                    placeholder="Estimated rent per month"
                    name="roofTop"
                    required
                    onChange={(e) => onChangeFacilities(e)}
                    height="300px"
                    checked={facilities?.includes("roofTop")}
                  />
                  <Typography>Roof Top</Typography>
                </Box>
                <Box
                  className="col-12 col-sm-6 col-md-3"
                  sx={{
                    display: "flex",
                    justifyContent: "left",
                    gap: "10px",
                    alignItems: "center",
                  }}
                >
                  <input
                    type="checkbox"
                    className=""
                    id="parking"
                    placeholder="Estimated rent per month"
                    name="parking"
                    required
                    onChange={(e) => onChangeFacilities(e)}
                    height="300px"
                    checked={facilities?.includes("parking")}
                  />
                  <Typography>Parking</Typography>
                </Box>
                <Box
                  className="col-12 col-sm-6 col-md-3"
                  sx={{
                    display: "flex",
                    justifyContent: "left",
                    gap: "10px",
                    alignItems: "center",
                  }}
                >
                  <input
                    type="checkbox"
                    className=""
                    id="securityCameras"
                    placeholder="Estimated rent per month"
                    name="securityCameras"
                    required
                    onChange={(e) => onChangeFacilities(e)}
                    height="300px"
                    checked={facilities?.includes("securityCameras")}
                  />
                  <Typography>Security Cameras</Typography>
                </Box>
                <Box
                  className="col-12 col-sm-6 col-md-3"
                  sx={{
                    display: "flex",
                    justifyContent: "left",
                    gap: "10px",
                    alignItems: "center",
                  }}
                >
                  <input
                    type="checkbox"
                    className=""
                    id="attachBath"
                    placeholder="Estimated rent per month"
                    name="attachBath"
                    required
                    onChange={(e) => onChangeFacilities(e)}
                    height="300px"
                    checked={facilities?.includes("attachBath")}
                  />
                  <Typography>Attach Bath</Typography>
                </Box>
                <Box
                  className="col-12 col-sm-6 col-md-3"
                  sx={{
                    display: "flex",
                    justifyContent: "left",
                    gap: "10px",
                    alignItems: "center",
                  }}
                >
                  <input
                    type="checkbox"
                    className=""
                    id="mess"
                    placeholder="Estimated rent per month"
                    name="mess"
                    required
                    onChange={(e) => onChangeFacilities(e)}
                    height="300px"
                    checked={facilities?.includes("mess")}
                  />
                  <Typography>Mess</Typography>
                </Box>
              </Box>

              <textarea
                className="text-feild input__field__asc"
                id="tags_of_hostel"
                placeholder="Tags (separate by commas)"
                name="tagsText"
                required
                onChange={(e) => onChange(e)}
              />
              {errors.tags && <p className="error__para">{errors.tags}</p>}
              <p>Tags : </p>
              {tags && (
                <Box className="tags__container">
                  {tags.map((tag) => (
                    <span>{tag} </span>
                  ))}
                </Box>
              )}
              {/* <textarea
                className="text-feild input__field__asc"
                id="description_of_hostel"
                placeholder="Description"
                name="description"
                required
                onChange={(e) => onChange(e)}
              />
              {errors.description && (
                <p className="error__para">{errors.description}</p>
              )} */}
              <Box name="date" id="date" required />
              <button
                className=" asc__submit__form__button cancel__form__btn"
                onClick={() => navigate("/hostels")}
              >
                Cancel
              </button>

              <button
                className=" mt-3 asc__submit__form__button"
                id="submitbutton_of_projects"
                onClick={(e) => submitData(e)}
              >
                {params?.hostelId ? "Update" : "Submit"}
              </button>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
